import { useEffect, useState } from "react";
import {
  saveDonorDetailsLinkingAccount,
  getCardProfileDataLinkingAccount } from
"../../../services/epic/bloodDonation";
import { useNavigate } from "react-router-dom";
import { getMaskedMobileNo } from "../../../common/MaskedMobileNo";
import { convert } from "../../../utils/util";

const OtpVerification = ({ profile, setOtpVerification, linkSuccessful, setLinkSuccessful, email,
  requestStep,
  setRequestStep, id, donorId, emiratesId, donorYear, emiratesYear, userName, translationMap }) => {
  const [, setOtpError] = useState("");
  const [alert, setAlert] = useState(false);
  const [error, setError] = useState(false);

  const [otp, setOtp] = useState({
    first: "",
    second: "",
    third: "",
    fourth: ""
  });
  const [timer, setTimer] = useState(300);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);
  const [isBlocked, setIsBlocked] = useState(false);
  const [blockTimer, setBlockTimer] = useState(0);
  const [, setOtpEntered] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (blockTimer > 0) {
      const interval = setInterval(() => {
        setBlockTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (blockTimer === 0 && isBlocked) {
      setIsBlocked(false);
    }
  }, [blockTimer, isBlocked]);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      setIsResendEnabled(true);
    }
  }, [timer]);

  const handleOtpChange = (e) => {
    setError(false);
    setOtpError("");
    const { id, value } = e.target;
    if (/^\d?$/.test(value)) {
      setOtp((prevOtp) => {
        const updatedOtp = { ...prevOtp, [id.split("-")[1]]: value };
        const allInputsCleared = Object.values(updatedOtp).every(
          (val) => val === ""
        );
        setIsContinueDisabled(allInputsCleared);
        return updatedOtp;
      });
      if (value.length === 1 && e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      }
    }
  };

  const handleResendCode = async () => {
    setError("");
    if (isBlocked) {
      setError(translationMap?.otpBlocked || "Your OTP has been blocked due to multiple failed attempts. Please try again after 5 minutes.");
      return;
    }
    const info = await getCardProfileDataLinkingAccount(donorId, emiratesId, convert(donorYear), convert(emiratesYear), userName);
    if (info) {
      setAlert(true);
      setIsResendEnabled(false);
      setTimer(300);
    }
  };

  const otpVerification = async () => {
    setAlert(false);
    setError("");
    const fullOtp = otp.first + otp.second + otp.third + otp.fourth;
    try {
      const result = await saveDonorDetailsLinkingAccount(fullOtp, id, donorId, emiratesId, convert(donorYear), convert(emiratesYear), email, "1");
      setOtp({ first: "", second: "", third: "", fourth: "" });
      if (result?.data?.success) {
        if (requestStep === -1)
        {
          setLinkSuccessful(true);
          setRequestStep(-1);
        } else
        if (requestStep === 1) {
          setRequestStep(2);
        }
        navigate("/");
        setError(false);
      }
    } catch (error) {
      setError(true);
      if (error.response && error.response.status === 400) {
        if (error.response.data.error === "otpBlocked") {
          setIsBlocked(true);
          setBlockTimer(300);
          setError(
            translationMap?.otpBlocked || "Your OTP has been blocked due to multiple failed attempts. Please try again after 5 minutes."
          );
        } else
        if (error.response.data.error === "otpExpired") {
          setError(translationMap?.otpExpired);
        } else {
          setError(translationMap?.invalidOtp);
        }
      } else {
        setError(translationMap?.unexpectedError);
      }
      setOtp({ first: "", second: "", third: "", fourth: "" });
      //console.error("OTP verification error:", error);
    }
    setOtpEntered((prevOtp) => prevOtp + 1);
    setOtp({ first: "", second: "", third: "", fourth: "" });
  };

  const handleCloseModal = async () => {
    setOtpVerification(false);
    const fullOtp = otp.first + otp.second + otp.third + otp.fourth;
    await saveDonorDetailsLinkingAccount(fullOtp, id, donorId, emiratesId, convert(donorYear), convert(emiratesYear), email, "1");
  };

  return (
    <>
      <div
        className="modal fade Custom_Modal_Box show"
        id="mobilenumberverification"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{ display: "block" }}>
        
        <div
          className="modal-dialog CoveragePlan_Dialog2"
          role="document">
          
          <div className="modal-content">
            <div className="modal-header">
              <div className="Title_Inner_Box">
                <h6 className="MainTitleOne">{translationMap?.mobileNoVerification}</h6>
              </div>
            </div>
            {alert &&
            <div className="Alert_Main_Box">
                <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                  <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  onClick={() => setAlert(false)}>
                  
                    &times;
                  </button>
                  <div className="Icon_box">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a>
                      <span className="material-symbols-outlined">
                        check_circle
                      </span>
                    </a>
                  </div>
                  <div className="alert_text">
                    <h6>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a>{translationMap?.otpResendSuccess}</a>
                    </h6>
                  </div>
                </div>
              </div>
            }
            <div className="modal-body">
              <div className="Manage_Dependent_Modal_Box3">
                <p className="para_txt">
                  {translationMap?.pleaseEnterOtp}{" "}
                  <span style={{ direction: "ltr" }}>{getMaskedMobileNo(profile?.mobileNumber)}</span>
                </p>
                <div className="opt_main_box">
                  <p>{translationMap?.verificationCode || "Verification Code"}</p>
                  <div className="custom_row" style={{ direction: "ltr" }}>
                    {["first", "second", "third", "fourth"].map(
                      (digit, index) =>
                      <input
                        key={digit}
                        id={`otp-${digit}`}
                        type="number"
                        inputmode="numeric"
                        min="0"
                        max="9"
                        className={`input_number_verify ${
                        error ? "errorRedAlert" : ""}`
                        }
                        placeholder="0"
                        style={{ MozAppearance: "textfield" }}
                        value={otp[digit]}
                        onChange={handleOtpChange}
                        onKeyDown={(e) => {
                          if (
                          e.key === "Backspace" &&
                          !otp[digit] &&
                          index > 0)
                          {
                            document
                            .querySelectorAll(".input_number_verify")[
                            index - 1].focus();
                          }
                        }} />


                    )}
                  </div>
                  {error &&
                  <div className="verifyContent">
                    <p className="codeErrorAlert">{error}</p>
                  </div>
                  }
                  <p className="opt_timer_box">
                    {timer > 0 &&
                    <span className="optTimer">{`(${Math.floor(
                        timer / 60
                      )}:${String(timer % 60).padStart(2, "0")})`}</span>
                    }
                  </p>
                </div>
                <h6 className="Gray_Title">
                  {translationMap?.dintGetCode}{" "}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    onClick={() => {
                      if (isResendEnabled) {
                        handleResendCode();
                      }
                    }}
                    style={{
                      color: isResendEnabled ? "black" : "gray",
                      cursor: isResendEnabled ? "pointer" : "not-allowed"
                    }}>
                    
                    {translationMap?.clickToResend}
                  </a>
                </h6>
              </div>
            </div>

            <div className="modal-footer modal_footer_btn_box2">
              <button
                type="button"
                className="btn bluetrans_btn_link"
                data-dismiss="modal"
                onClick={handleCloseModal}>
                
                {translationMap?.back}
              </button>
              <button
                onClick={otpVerification}
                type="button"
                data-dismiss="modal"
                className={`${
                isContinueDisabled ? "disabled_btn_link" : "btn blue_btn_link"}`
                }
                disabled={isContinueDisabled}>
                
                {" "}
                {translationMap?.continue}{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>);

};

export default OtpVerification;